<template>
  <div class="modif-box">
    <h2>{{$t('menu_settings.addition')}}</h2>
    <div class="modif-card">
      <h3>
        {{ modificator.name }}
        <span class="price">{{modificator.price}}₴</span>
      </h3>
      <!-- <p>Weight: 228g</p> -->
    </div>
    <button class="round-button" @click="emitEdit">
      {{$t('menu_settings.edit')}}
    </button>
  </div>
</template>

<script>
export default {
  props: {
    modificator: Object
  },
  methods: {
    emitEdit() {
      this.$emit('edit');
    }
  }
}
</script>

<style scoped>
h2 {
  font-weight: 500;
  font-size: 3vh;
  margin-bottom: 0;
  color: #ffffff;
}

h3 {
  font-size: 2.2vh;
  margin: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

span {
  float: right;
  font-size: 3.3vh;
}

p {
  color: #a4a3a1;
  margin: 0;
}

.modif-card {
  border-radius: 1.5vh;
  background: #ededed;
  margin-top: 1.7vh;
  padding: 2.2vh;
  /* min-height: 50vh; */
  height: 70vh;
  width: 37vh;
  position: relative;
}

.modif-box {
    position: relative;
    height: 82.3vh;
}

.modif-box button {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0 auto;
}
</style>